module.exports = __webpack_public_path__ + "static/media/Army Address Clergy.6da20502.jpg";